import { useTranslations } from 'next-intl';
import cx from 'classnames';
import { CatIconSuccessFilled } from 'components/blocks-components';
import styles from '../../../product-page.module.scss';

interface FbtFitmentProps {
  isSerialCompatible: boolean;
}

const FbtFitment = ({ isSerialCompatible }: FbtFitmentProps) => {
  const t = useTranslations();
  return (
    isSerialCompatible && (
      <div className="d-flex align-items-center mb-2">
        <CatIconSuccessFilled color="success" className="pe-1" />
        <span
          className={cx(
            'cat-u-theme-typography-footnote-bold',
            styles['fbt-factory-fitment']
          )}
        >
          {t('PART_FACTORY_FIT')}
        </span>
      </div>
    )
  );
};

export default FbtFitment;
